import { useSnackbar } from 'notistack';
import React, { memo, useContext, useEffect, useReducer } from 'react';
import { isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';
import { fetchSponsorsAPI } from '../../../apiCalls/SponsorAPICalls';
import Spinner1 from '../../spinners/spinner1/Spinner1';
import Title3 from '../../title/title3/Title3';
import './css/SponsorsComponent4.css';
import { cdnImage, ImageWidth } from '../../../../catalog/ImageCdn';

const initialState = {
    sponsors: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchSponsors':
            return { ...state, sponsors: action.sponsors };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const SponsorsComponent4 = () => {
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetchSponsors() {
            setState({ type: 'setLoadingSpinner', loadingSpinner: true });
            await fetchSponsorsAPI(globalState.accountId, setState, enqueueSnackbar);
            setState({ type: 'setLoadingSpinner', loadingSpinner: false });
        }
        fetchSponsors();
    }, []);

    const createUrl = (url) => {
        if (url.includes('http')) {
            return url;
        }
        return `http://${url}`;
    };

    // Fewer than 5 sponsors don't fill a scrolling strip; phones and tablets show them as a 2x2 grid instead.
    const STRIP_MIN_SPONSORS = 5;
    const showGrid = state.sponsors.length < STRIP_MIN_SPONSORS;

    // Phone-only scrolling strip. The list is rendered twice so the loop is seamless; the copy is hidden from screen readers and tab order.
    const getStripItem = (sponsor, copy) => {
        const content = isValidString(sponsor.logo)
            ? (<img className="sponsors-component4-strip-logo" src={cdnImage(sponsor.logo, ImageWidth.THUMB)} decoding="async" alt={isValidString(sponsor.name) ? sponsor.name : 'Sponsor Image'} />)
            : (<span className="sponsors-component4-strip-name font-weight-700 text-gray">{sponsor.name}</span>);
        if (isValidString(sponsor.url)) {
            return (
                <a key={`${sponsor.id}-${copy}`} className="sponsors-component4-strip-item text-no-underline" href={createUrl(sponsor.url)} target="_blank" rel="noreferrer" aria-hidden={copy ? 'true' : undefined} tabIndex={copy ? -1 : undefined}>{content}</a>
            );
        }
        return (<div key={`${sponsor.id}-${copy}`} className="sponsors-component4-strip-item" aria-hidden={copy ? 'true' : undefined}>{content}</div>);
    };

    return (
        <>
            {state.sponsors.length > 0 ? (
                <div className="sponsors-component4-container box-shadow-black x-center p-t-20px p-b-20px p-l-50px p-r-50px m-t-50px">
                    <Title3 title="Sponsors" />
                    {!state.loadingSpinner ? (
                        <div className={`sponsors-component4-strip-container full-width${showGrid ? ' sponsors-component4-strip-container-grid' : ''}`}>
                            {showGrid ? (
                                <div className="sponsors-component4-grid">
                                    {state.sponsors.map((sponsor) => { return getStripItem(sponsor, false); })}
                                </div>
                            ) : (
                                <div className="sponsors-component4-strip">
                                    <div className="sponsors-component4-strip-track" style={{ animationDuration: `${Math.max(state.sponsors.length * 3, 12)}s` }}>
                                        {state.sponsors.map((sponsor) => { return getStripItem(sponsor, false); })}
                                        {state.sponsors.map((sponsor) => { return getStripItem(sponsor, true); })}
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : null}
                    <div className="sponsors-component4 full-width m-t-50px">
                        {state.loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                            <>
                                {state.sponsors.map((sponsor) => {
                                    return (
                                        <React.Fragment key={sponsor.id}>
                                            {isValidString(sponsor.logo) ? (
                                                <>
                                                    {isValidString(sponsor.url) ? (
                                                        <a className="sponsors-component4-sponsor m-t-20px m-b-20px text-no-underline" href={createUrl(sponsor.url)} target="_blank" rel="noreferrer">
                                                            <img className="sponsors-component4-sponsor-logo" src={cdnImage(sponsor.logo, ImageWidth.THUMB)} loading="lazy" decoding="async" alt={isValidString(sponsor.name) ? sponsor.name : 'Sponsor Image'} />
                                                            {/* <p className="sponsors-component4-sponsor-title font-size-xl text-gray m-t-0 m-b-0">{sponsor.name}</p> */}
                                                        </a>
                                                    ) : (
                                                        <div className="sponsors-component4-sponsor m-t-20px m-b-20px text-no-underline" href={createUrl(sponsor.url)}>
                                                            <img className="sponsors-component4-sponsor-logo" src={cdnImage(sponsor.logo, ImageWidth.THUMB)} loading="lazy" decoding="async" alt={isValidString(sponsor.name) ? sponsor.name : 'Sponsor Image'} />
                                                            {/* <p className="sponsors-component4-sponsor-title font-size-xl text-gray m-t-0 m-b-0">{sponsor.name}</p> */}
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {isValidString(sponsor.url) ? (
                                                        <a className="sponsors-component4-sponsor m-t-20px m-b-20px text-no-underline" href={createUrl(sponsor.url)} target="_blank" rel="noreferrer">
                                                            <p className="sponsors-component4-sponsor-title font-size-4xl text-gray m-t-0 m-b-0">{sponsor.name}</p>
                                                        </a>
                                                    ) : (
                                                        <div className="sponsors-component4-sponsor m-t-20px m-b-20px text-no-underline" href={createUrl(sponsor.url)}>
                                                            <p className="sponsors-component4-sponsor-title font-size-4xl text-gray m-t-0 m-b-0">{sponsor.name}</p>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </>
                        )}
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default memo(SponsorsComponent4);
